<template>
  <section>
    <product-detail :product="product"/>
  </section>
</template>

<script>
import ProductDetail from '~/components/ProductDetail';
import ECommerceGtm from '~/plugins/mixins/e-commerce-gtm';

export default {
  components: {
    ProductDetail,
  },
  mixins: [ECommerceGtm],
  async asyncData({params, $axios, error}) {
    try {
      const {data} = await $axios.get(`/products/${params.product}`);

      return {
        product: data.data,
      };
    } catch (e) {
      error({statusCode: 404, message: e.message});
    }
  },
  data: () => ({
    product: null,
  }),
  mounted() {
    this.gtmPushClick(this.product);
  },
  head() {
    return {
      title: this.product?.title,
    };
  },
};
</script>
